import KeyboardKeyIcon from '@/components/ui/keyboard-key-icon';
import { HOTKEYS } from '@/lib/hotkeys';
import { createFileRoute } from '@tanstack/react-router';
import { capitalize } from 'lodash';
import { observer } from 'mobx-react-lite';

export const Route = createFileRoute('/(authenticated)/hotkeys/')({
  component: HotkeysPageWrapper,
});

const hotkeyMappingKeyToText = ({ key }: { key: string }) => {
  return key
    .split('_')
    .map((word, index) =>
      index === 0 ? capitalize(word.toLowerCase()) : word.toLowerCase(),
    )
    .join(' ');
};

const HotkeysPage = observer(() => {
  return (
    <div className="flex flex-col w-full h-screen max-w-5xl mx-auto p-6 dark:bg-dark overflow-y-auto">
      <div className="mb-8">
        <h1 className="text-2xl  mb-2 dark:text-white">Hotkeys</h1>
        <p className="text-muted-foreground">
          Hotkeys are a way to quickly navigate the platform.
        </p>
      </div>

      <div className="mb-10">
        <div className="flex flex-col mb-2">
          <h2 className="text-lg">Hotkeys</h2>
          <div className="flex flex-col gap-2">
            {Object.entries(HOTKEYS).map(([key, value]) => (
              <div
                key={key}
                className="flex flex-row gap-2 w-1/2 justify-between"
              >
                <div className="text-sm text-muted-foreground">
                  {hotkeyMappingKeyToText({ key })}:
                </div>
                <div className="flex flex-row gap-1">
                  <KeyboardKeyIcon>{value}</KeyboardKeyIcon>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

function HotkeysPageWrapper() {
  return <HotkeysPage />;
}
